import * as t from "io-ts";
import { nullable, placeT } from "./index";
import { withFallback } from "io-ts-types";
export const splitCargoReqT = t.strict({
    cargoId: t.string,
    date: t.string,
    place: placeT,
});
const newRouteOptionT = t.union([
    t.literal("UNDISPATCHED"),
    t.literal("NEW_ROUTE"),
]);
export const splitRouteReqT = t.strict({
    routeId: t.string,
    cargosIds: t.array(t.string),
    date: t.string,
    place: placeT,
    truckId: nullable(t.string),
    trailerId: nullable(t.string),
    driverId: nullable(t.string),
    teamId: withFallback(nullable(t.string), null),
    newRouteOption: newRouteOptionT,
    routeName: nullable(t.string),
});
export const unsplitRouteReqT = t.strict({
    cargosIds: t.array(t.string),
});
//# sourceMappingURL=split-cargos-routes.js.map